import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ProAttrField } from '../../../../atoms/AttrField/AttrField';
import { ProButton } from '../../../../atoms/Button/ProButton';
import { ProIconButton } from '../../../../atoms/Button/ProIconButton';
import { ProIconDataButtons } from '../../../../atoms/Icons/IconData';
import { SelectionContext, SelectionType } from '../../../../contexts/SelectionContext';
import { ProIntent, ProSize } from '../../../../utils/enums';
import { getPersonsName } from '../../../../utils/helpers';
import { Components } from '../../../../utils/types';
import { proLinkStructure } from '../../../Menu/Navigate';

export const ResponsiblePersonFieldForQuality = ({
    data,
    isDisabled,
    setData,
}: {
    data: Components.Schemas.WBSElementDTO;
    isDisabled: boolean;
    setData: Dispatch<SetStateAction<Components.Schemas.WBSElementDTO | undefined>>;
}) => {
    const { t } = useTranslation();
    const { setRenderSelectionButton, setSelectedElementId, turnSelectionOff, setSelectionMode } =
        useContext(SelectionContext);

    const setSelectFunction = (person: Components.Schemas.PersonDTO) => {
        setData((cur) => ({ ...cur, responsiblePerson: person }));
    };

    const selectFunction = () => {
        setSelectedElementId(data?.responsiblePerson?.id);
        setSelectionMode(SelectionType.HumanResource);

        setRenderSelectionButton(() => (humanResource: Components.Schemas.HumanResourceDTO) => (
            <div className="ProTable--actionCell">
                <ProButton
                    onClick={turnSelectionOff}
                    text={t('buttons.cancel')}
                    mainIntent={ProIntent.Transparent}
                    hoverIntent={ProIntent.Error}
                    lineIntent={ProIntent.Error}
                    size={ProSize.XSmall}
                    placement="bottom"
                />
                <ProButton
                    text={t('buttons.select')}
                    mainIntent={ProIntent.Success}
                    onClick={() => {
                        setSelectFunction(humanResource);
                        turnSelectionOff();
                    }}
                />
            </div>
        ));
    };

    useEffect(() => {
        setRenderSelectionButton(() => (
            <div className="ProTable--actionCell">
                <ProButton
                    onClick={turnSelectionOff}
                    text={t('buttons.cancel')}
                    mainIntent={ProIntent.Transparent}
                    hoverIntent={ProIntent.Error}
                    lineIntent={ProIntent.Error}
                    size={ProSize.XSmall}
                    placement="bottom"
                />
                <ProButton
                    text={t('buttons.select')}
                    mainIntent={ProIntent.Success}
                    onClick={() => {
                        turnSelectionOff();
                    }}
                />
            </div>
        ));
    }, [setRenderSelectionButton]);

    return (
        <ProAttrField
            name={t('windows.responsiblePerson')}
            value={getPersonsName(t, data.responsiblePerson)}
            // value={`${data.responsiblePerson?.firstName ?? ''} ${data.responsiblePerson?.lastName ?? 'not defined'}`}
        >
            {data.responsiblePerson && (
                <Link to={`${proLinkStructure.portfolioManagement.people.link}/${data.responsiblePerson?.id}`}>
                    <ProIconButton
                        tooltip={t('buttons.goToPerson')}
                        icon={ProIconDataButtons.arrow_right_xs}
                        onClick={() => {}}
                        size={ProSize.XSmall}
                        mainIntent={ProIntent.LightBlue}
                        disabled={false}
                    />
                </Link>
            )}
            <ProIconButton
                tooltip={t('buttons.assignResponsiblePerson')}
                icon={data.responsiblePerson ? ProIconDataButtons.refresh_xs : ProIconDataButtons.add_xs}
                onClick={selectFunction}
                // size={ProSize.XSmall}
                mainIntent={isDisabled ? ProIntent.LightBlue : ProIntent.Success}
                disabled={isDisabled}
                placement="top"
                small
            />
        </ProAttrField>
    );
};
